(async () => {
    const {
        loadScript,
        loadStyle
    } = await import(window.theme.modules.utils);

    const baseComponent = await import(window.theme.modules.baseComponent);

    // Bouton son : un seul écouteur délégué pour toute la page.
    if (!window.__ftBgSoundBound) {
        window.__ftBgSoundBound = true;
        document.addEventListener('click', (e) => {
            const btn = e.target.closest('[data-ft-sound]');
            if (!btn) return;
            const on = btn.getAttribute('aria-pressed') !== 'true';
            btn.setAttribute('aria-pressed', String(on));
            btn.setAttribute('aria-label', on ? 'Couper le son' : 'Activer le son');
            document.dispatchEvent(new CustomEvent('ft:bg-sound', { detail: { on } }));
        });
    }

    customElements.define('video-bg', class extends baseComponent.default {
        elements = {
            player: '[data-player]'
        }

        playerInited = false;
        soundOn = false;

        async render() {
            this.on('stopVideoBg', () => {
                if(this.player) {
                    this.player.pause();
                }
            })
            this.on('playVideoBg', () => {
                if(this.player) {
                    this.safePlay();
                }
            })
            document.addEventListener('ft:bg-sound', (e) => {
                this.soundOn = !!e.detail?.on;
                this.applySound();
            });
        }

        applySound() {
            if (!this.player) return;
            try {
                this.player.muted = !this.soundOn;
                this.player.volume = this.soundOn ? 1 : 0;
            } catch(_) {}
            if (this.soundOn) this.safePlay();
        }

        // play() renvoie une promesse rejetée si le navigateur bloque la lecture.
        // Sans ce catch, la vidéo reste figée sur la première image.
        safePlay() {
            let p;
            try { p = this.player?.play(); } catch(_) { this.showStill(); return; }
            if (p && typeof p.catch === 'function') {
                p.catch(() => {
                    // Blocage : on force le muet et on retente une fois.
                    try {
                        this.player.muted = true;
                        this.player.volume = 0;
                        const p2 = this.player.play();
                        if (p2 && typeof p2.catch === 'function') {
                            p2.catch(() => this.fallbackToGesture());
                        }
                    } catch(_) { this.fallbackToGesture(); }
                });
            }
        }

        // Mode économie d'énergie (iOS) : Safari refuse TOUTE lecture automatique,
        // même en muet. On affiche au moins l'image de la vidéo, et on relance
        // dès le premier geste de l'utilisateur (touche, clic, scroll).
        fallbackToGesture() {
            this.showStill();
            if (this._gestureArmed) return;
            this._gestureArmed = true;
            const events = ['pointerdown', 'touchstart', 'click', 'keydown', 'scroll'];
            const opts = { passive: true };
            this._retry = () => this.safePlay();
            events.forEach(ev => document.addEventListener(ev, this._retry, opts));
            this._disarm = () => events.forEach(ev => document.removeEventListener(ev, this._retry, opts));
        }

        // Enlève le voile de chargement pour que le poster/la 1re image soit visible
        // au lieu d'un bloc noir quand la lecture ne démarre pas.
        showStill() {
            this.removeAttribute('loading');
        }

        async onIntersect(isIntersecting) {
            if (isIntersecting) {
                if(!this.player) {
                    this.setAttribute('loading', '');
                    await this.initPlayer();
                } else {
                    this.safePlay();
                }
            }
        if(!isIntersecting && this.player) {
                this.player.pause();
            }
        }

        async initPlayer() {
            loadStyle('https://cdn.plyr.io/3.6.12/plyr.css');
            if(!window.Plyr) {
                await loadScript(window.theme.scripts.Plyr);
            }
            this.playerInited = true;

            // Les navigateurs n'autorisent l'autoplay que sur une vidéo muette.
            const video = this.querySelector('video');
            if (video) {
                video.muted = true;
                video.defaultMuted = true;
                video.playsInline = true;
                video.setAttribute('muted', '');
                video.setAttribute('playsinline', '');
            }

            this.player = new window.Plyr(this.$player, {
                muted: true,
                volume: 0,
                loop: { active: this.$player.tagName === 'VIDEO' }
            });
            this.player.on('ended', () => {
                this.player.restart();
            })
            this.player.on('ready', () => {
                this.applySound();
                this.safePlay();
            })
            this.player.on('playing', () => {
                this.removeAttribute('loading');
                if (this._disarm) { this._disarm(); this._disarm = null; this._gestureArmed = false; }
            })

            // Filet de sécurité : si rien ne démarre en 2,5 s (réseau lent, économie
            // d'énergie…), on découvre quand même le visuel plutôt que du noir.
            setTimeout(() => {
                if (this.hasAttribute('loading')) this.fallbackToGesture();
            }, 2500);

            // Retour sur l'onglet : le navigateur a pu mettre la lecture en pause.
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'visible') this.safePlay();
            });
        }
    });
})();
